export const enum PlayerElementTypesEnum {
  EXTERNAL_CHALLENGE = "challenge",
  IMAGE = "image",
  INTERACTIVE = "interactive",
  NO_GUEST_PERMISSION = "no_guest_permission",
  TEXT_IMAGE = "text_image",
  VIDEO = "video",
  CHATBOT = "chatbot",
}
